import { TextField } from '@src/shared/ui/fields';
import { useTranslation } from 'react-i18next';

type NotesHrFieldProps = {
  disabled?: boolean;
};

/**
 * Notes the absentee's HR manager keeps on an absence.
 *
 * Only ever rendered for them: the server leaves the field out of everybody
 * else's view of the row, so showing the box to anyone else would offer an
 * empty textarea that silently discards whatever is typed into it.
 */
export default function NotesHrField({ disabled = false }: NotesHrFieldProps) {
  const { t } = useTranslation();

  return (
    <TextField
      disabled={disabled}
      multiline
      fullWidth
      label={t('absence.schedule.field_notes_hr', 'Notes HR')}
      name="notesHr"
      rows={5}
    />
  );
}
